<script lang="ts">
	import type { ComponentProps, Snippet } from 'svelte'
	import type { i18n } from 'types/common'

	import { RadioButtonGroup } from '@isoftdata/svelte-checkbox'
	import { booleanToString } from '@isoftdata/utility-boolean'
	import { stringToBoolean } from '@isoftdata/utility-string'
	import { getContext } from 'svelte'

	interface Props extends Omit<
		ComponentProps<typeof RadioButtonGroup<string>>,
		'allowUnset' | 'btnGroupClass' | 'labelParentClass' | 'options' | 'value' | 'change'
	> {
		id?: string
		label?: string
		hint?: Snippet | string
		value?: boolean | null
		disabled?: boolean
		/** The radio group's raw value: 'True', 'False', or '' when unset */
		change?: (value: string) => void
	}

	let {
		//,
		value = $bindable(null),
		change,
		...rest
	}: Props = $props()

	const { t: translate } = getContext<i18n>('i18next')
</script>

<RadioButtonGroup
	{...rest}
	allowUnset
	{change}
	labelParentClass="mb-0"
	btnGroupClass="mb-1 w-100"
	options={[
		{ label: translate('common:yes', 'Yes'), value: 'True' },
		{ label: translate('common:no', 'No'), value: 'False' },
	]}
	bind:value={() => (value === null ? '' : booleanToString(value)), v => (value = v === '' ? null : stringToBoolean(v))}
></RadioButtonGroup>
